import React, { useState, useContext } from "react";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { CloudDownloadOutlined } from "@mui/icons-material";
import { Utils } from "common/Utils";
import { apiUrls } from "common/ApiUrls";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import { Document, Page, pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function PdfViewerModal({ open, documentId, filename, description, contents, handleClose, handleDownloadUrl }) {
  const { companyId } = useContext(PrivateRoutesContext);

  const [numPages, setNumPages] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const downloadDocument = () => {
      setIsDownloading(true);

      Utils.downloadFile(handleDownloadUrl,
      filename,
      null,
      () => {
      //   setErrorText("An Error occurred downloading the file.");
      //   setDoShowError(true);
      },
      () => {
        setIsDownloading(false);
      });
  }

    return (
      <Dialog
        open={open}
        maxWidth={false}
      >
        <DialogTitle>{documentId ? `${description} - ${filename}` : "Unable to load document"}</DialogTitle>
        <DialogContent>
          {documentId ?
            <Document
              file={contents ? `data:application/pdf;base64,${contents}` : `${apiUrls.downloadPlanDocument(companyId, documentId)}`}
              options={{ workerSrc: "/pdf.worker.js" }}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={console.error}
            >
              {Array.from(new Array(numPages), (el, index) => (
                <Page key={`page_${index + 1}`} pageNumber={index + 1} />
              ))}
            </Document>
          : <Box>Error Loading document</Box> }
        </DialogContent>

        <DialogActions>
          {documentId ?
            <LoadingButton
              onClick={downloadDocument}
              color="primary"
              variant="outlined"
              startIcon={<CloudDownloadOutlined />}
              loading={isDownloading}
              loadingPosition="start"
            >
              Download File
            </LoadingButton> : null
          }
          <Button onClick={handleClose} color="primary" variant="outlined" disabled={isDownloading}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
}